import React, { useCallback, useState } from 'react';
import { triggerSignUp } from '@fiverr-private/identification_triggers';
import pathfinder from '@fiverr-private/pathfinder';
import { translate } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/button';
import { Container } from '@fiverr-private/layout_components';
import { sendBigQueryEvent } from '../../../utils/bigQuery';
import { BIGQUERY_EVENT } from './constants';

export const JoinLink = () => {
    const [loading, setLoading] = useState(false);
    const path = pathfinder(
        'join',
        {},
        {
            query: {
                source: 'top_nav',
            },
        }
    );

    const onClick = useCallback(
        async (event) => {
            try {
                event.preventDefault();
                setLoading(true);
                await triggerSignUp({ modalOptions: { source: 'header_join_link' } });
                sendBigQueryEvent(BIGQUERY_EVENT);
            } catch {
                window.location.assign(path);
            } finally {
                setLoading(false);
            }
        },
        [path]
    );

    return (
        <Container>
            <Container minWidth={{ default: '53px', sm: '88px' }}></Container>
            <Button
                href={path}
                loading={loading}
                rel="nofollow"
                type="button"
                onClick={onClick}
                fullWidth
                size={{
                    default: 'sm',
                    sm: 'md',
                }}
            >
                {translate('header.join')}
            </Button>
        </Container>
    );
};
